var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMotorhomePlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.818 99c-3.205 0-6.22-1.248-8.485-3.515A11.92 11.92 0 0 1 20.817 87a11.92 11.92 0 0 1 3.514-8.485A11.92 11.92 0 0 1 32.819 75c6.617 0 12 5.382 12 12s-5.383 12-12 12Zm0-18c-1.603 0-3.11.625-4.243 1.757A5.963 5.963 0 0 0 26.817 87c0 1.603.625 3.11 1.758 4.243A5.963 5.963 0 0 0 32.818 93c3.307 0 6-2.692 6-6s-2.693-6-6-6ZM86.817 99c-3.204 0-6.22-1.248-8.484-3.515A11.92 11.92 0 0 1 74.816 87a11.92 11.92 0 0 1 3.516-8.485A11.92 11.92 0 0 1 86.816 75c6.618 0 12 5.382 12 12s-5.382 12-12 12Zm0-18c-1.602 0-3.11.625-4.242 1.757A5.963 5.963 0 0 0 80.817 87c0 1.603.626 3.11 1.758 4.243A5.963 5.963 0 0 0 86.817 93c3.308 0 6-2.692 6-6s-2.692-6-6-6Z",
    fill: "#222",
    className: "fill"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M101 90h-5.183v-6H101a1 1 0 0 0 1-1V67a.996.996 0 0 0-1-1h-8v-6h8c1.87 0 3.627.727 4.95 2.05A6.955 6.955 0 0 1 108 67v16c0 3.86-3.14 7-7 7ZM54 45H11.818V34c0-3.86 3.14-7 7-7h44v6h-44a1 1 0 0 0-1 1v5H54v6Z",
    fill: "#222",
    className: "fill"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M105 69h-9v6h9v-6ZM23.817 90h-5c-3.86 0-7-3.14-7-7V48h6v35a1 1 0 0 0 1 1h5v6ZM68.817 90h-21V59c0-2.758 2.093-5 4.668-5h10.333v6h6v30Zm-15-6h9V60h-9v24Z",
    fill: "#222",
    className: "fill"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M77.817 84h-36v6h36v-6ZM32.818 69a8.94 8.94 0 0 1-6.365-2.635A8.94 8.94 0 0 1 23.817 60a8.94 8.94 0 0 1 2.636-6.365A8.94 8.94 0 0 1 32.818 51c4.962 0 9 4.038 9 9 0 4.963-4.038 9-9 9Zm0-12c-.803 0-1.555.313-2.12.877a2.976 2.976 0 0 0-.878 2.12c0 .803.313 1.556.878 2.123a3.002 3.002 0 0 0 5.122-2.122c0-1.655-1.345-3-3-3l-.002.002ZM82.317 69c-14.06 0-25.5-11.44-25.5-25.5S68.258 18 82.317 18s25.501 11.44 25.501 25.5S96.378 69 82.318 69Zm0-45c-10.752 0-19.5 8.748-19.5 19.5S71.566 63 82.317 63c10.753 0 19.501-8.748 19.501-19.5S93.07 24 82.318 24Z",
    fill: "#222",
    className: "fill"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M85.317 30h-6v27h6V30Z",
    fill: "#222",
    className: "fill"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M95.817 40.5h-27v6h27v-6Z",
    fill: "#222",
    className: "fill"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMotorhomePlus);
export default __webpack_public_path__ + "static/media/motorhome-plus.62ee85c5.svg";
export { ForwardRef as ReactComponent };